import { ExtensibilityModeEnum } from 'owa-addins-types';
import {
    getComposeHostItemIndex,
    lazyTriggerAppointmentTimeChangedEvent,
    lazyOnLaunchEventTriggered,
    AppointmentComposeAdapter,
    getAdapter,
} from 'owa-addins-core';
import { isFeatureEnabled } from 'owa-feature-flags';
import LaunchEventType from 'owa-service/src/contract/LaunchEventType';

export default function triggerAppointmentTimeChanged(itemId: string) {
    const hostItemIndex = getComposeHostItemIndex(itemId);
    const adapter = getAdapter(hostItemIndex) as AppointmentComposeAdapter;
    if (adapter != null && adapter.mode === ExtensibilityModeEnum.AppointmentOrganizer) {
        const result = {
            start: adapter.getStartTime(),
            end: adapter.getEndTime(),
        };

        lazyTriggerAppointmentTimeChangedEvent
            .import()
            .then(triggerAppointmentTimeChangedEvent =>
                triggerAppointmentTimeChangedEvent(hostItemIndex, result)
            );

        if (
            isFeatureEnabled('addin-autoRun') &&
            isFeatureEnabled('addin-autoRun-appointmentTimeChangedEvent')
        ) {
            lazyOnLaunchEventTriggered.importAndExecute(
                hostItemIndex,
                LaunchEventType.OnAppointmentTimeChanged,
                { type: 'olkAppointmentTimeChanged', ...result }
            );
        }
    }
}
